<template>
  <div class="component-product-details-member-area-step-title">
    <div class="d-flex">
      <div class="circle" v-if="icon">
        <i :class="icon" :style="fa && 'font-size:24px'" />
      </div>
      <div class="justify-content-between">
        <div class="text-neutral-700 fs-20">{{ title }}</div>
        <div class="text-neutral-400 fs-14">{{ description }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    description: String,
    icon: String,
    fa: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.component-product-details-member-area-step-title {
  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 2px solid #9155ec;
    color: #9155ec;
    margin-right: 16px;

    i {
      font-size: 23px;
    }

    @media screen and (max-width: 991px) {
      font-size: 17px;
    }
  }
}
</style>
